define((require) => {
    "use strict";

    var template     = require("ui/editor/ZoomView.tpl"),
        EditorEvents = require("shared/services/EditorEvents"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        Keyboard     = require("services/Keyboard"),
        _            = require("underscore"),
        Storage      = require("shared/services/Storage");

    /**
     * The zoom control view.
     *
     * @class ZoomView
     * @constructor
     *
     * @cfg {ZoomModel} model The zoom model.
     */
    return ImprovedView.extend({

        template: template,

        _zoomModel: null,

        zoomBinding: {
            ".zoom-percent": {
                observe: "scale",
                onGet: function(scale) {
                    var percentage = Math.round(scale * 100) + "%";

                    return percentage;
                }
            },
            ".zoom-in": {
                attributes: [{
                    name: "disabled",
                    observe: "scale",
                    onGet: function() {
                        var disable = "";

                        if (this._zoomModel !== null && this._zoomModel.isMaxScale()) {
                            disable = "disabled";
                        }

                        return disable;
                    }
                }]
            },
            ".zoom-out": {
                attributes: [{
                    name: "disabled",
                    observe: "scale",
                    onGet: function() {
                        var disable = "";

                        if (this._zoomModel !== null && this._zoomModel.isMinScale()) {
                            disable = "disabled";
                        }

                        return disable;
                    }
                }]
            },
            ".reset-zoom": {
                attributes: [{
                    name: "disabled",
                    observe: "scale",
                    onGet: function() {
                        var disable = "";

                        if (this._zoomModel === null || this._zoomModel.get("scale") === 1) {
                            disable = "disable";
                        }

                        return disable;
                    }
                }]
            }
        },

        events: {
            "click .zoom-in": "_clickZoomInHandler",
            "click .zoom-out": "_clickZoomOutHandler",
            "click .reset-zoom": "_clickResetZoomHandler"
        },

        /**
         * Click handlers for the zoom buttons
         */
        _clickZoomInHandler: function() {
            this._zoomModel.scaleUp();
            EditorEvents.trigger(this.options.event, {
                zoomType: "in",
                triggerOrigin: "ZoomInButton"
            });
        },

        _clickZoomOutHandler: function() {
            this._zoomModel.scaleDown();
            EditorEvents.trigger(this.options.event, {
                zoomType: "out",
                triggerOrigin: "ZoomOutButton"
            });
        },

        _clickResetZoomHandler: function() {
            this._zoomModel.reset();
            EditorEvents.trigger(this.options.event, {
                zoomType: "reset",
                triggerOrigin: "ZoomResetButton"
            });
        },

        initialize: function() {
            this._zoomModel = this.options.zoomModel;

            var experienceId = this.options.experienceId;

            _.bindAll(this, "_clickZoomInHandler", "_clickZoomOutHandler", "_clickResetZoomHandler");

            if (this.options.persistZoom) {
                // Keep track of the scale factor
                this.listenTo(this._zoomModel, "change:scale", (model, value) => {
                    Storage.Local.update(Storage.Keys.EDITOR, experienceId + "-scaleFactor", value);
                });
            }
        },

        onRender: function() {
            this.stickit(this._zoomModel, this.zoomBinding);

            Keyboard.Shortcut.bind("+", this._clickZoomInHandler);
            Keyboard.Shortcut.bind("-", this._clickZoomOutHandler);
            Keyboard.Shortcut.bind("0", this._clickResetZoomHandler);
        },

        onClose: function() {
            Keyboard.Shortcut.unbind("+", this._clickZoomInHandler);
            Keyboard.Shortcut.unbind("-", this._clickZoomOutHandler);
            Keyboard.Shortcut.unbind("0", this._clickResetZoomHandler);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ZoomView.js